import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Product } from '../components/Customer/Data'

type ProductsState = {
  products: Product[]
}

const productsSlice = createSlice({
  name: 'products',
  initialState: {} as ProductsState,
  reducers: {
    setEnabledProducts(state, action: PayloadAction<Product[]>) {
      state.products = action.payload
    },
  },
})

export const { setEnabledProducts } = productsSlice.actions
export default productsSlice.reducer
